// extracted by mini-css-extract-plugin
export default {"outer":"YK","outernoline":"ZK","heading":"aL","text":"bL","inner":"cL"};
    if(module.hot) {
      // 1730991508713
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  